"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _luxon = require("luxon");
var _automationHooks = require("@airportlabs/automation-hooks");
var _ = require("../");
var _helpers = require("../helpers");
var _excluded = ["children", "value", "hasError", "placeholder", "isRequired", "disabled", "onChange", "onClose", "format", "w", "width", "align", "hideDoneButton", "withClearButton", "clearValue", "automationHook", "isHighlighted"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var propTypes = {
  /** Use children to change the way the trigger looks. */
  children: _propTypes["default"].any,
  /** Value as number of seconds */
  value: _propTypes["default"].number,
  /** Input placeholder */
  placeholder: _propTypes["default"].string,
  /** Required field. */
  isRequired: _propTypes["default"].bool,
  /** Wether this field should be displayed as having an error. */
  hasError: _propTypes["default"].bool,
  /** Function to change external state. Is called when the popover is closed.  */
  onChange: _propTypes["default"].func.isRequired,
  /** An additional function to be executed when the popover is closed. */
  onClose: _propTypes["default"].func,
  /** A string for a valid duration format. Defaults to "hh:mm:ss"
   * https://github.com/moment/luxon/blob/master/docs/math.md#basics */
  format: _propTypes["default"].string,
  /** React Tiny Popover API https://github.com/alexkatz/react-tiny-popover#popover
   * Alignment of the Popover relative to the input
   */
  align: _propTypes["default"].oneOf(["start", "center", "end"]),
  /** DEPRECATED: The width of the trigger field */
  width: _propTypes["default"].string,
  /** The width of the trigger field */
  w: _propTypes["default"].string,
  /** Disabled state */
  disabled: _propTypes["default"].bool,
  /** Wether to hide the done popover button. */
  hideDoneButton: _propTypes["default"].bool,
  /** Wether to hide the input clear button */
  withClearButton: _propTypes["default"].bool,
  /** Value for the field that gets set when the Input's clear button is
   * clicked. clearValue is important for formik to compare correct initial
   * values with the value that gets set onClear. By default it is `null`
   */
  clearValue: _propTypes["default"].any,
  /** Hook used for automation testing */
  automationHook: _propTypes["default"].string,
  /** Specifies if the current field is highlighted */
  isHighlighted: _propTypes["default"].bool
};
exports.propTypes = propTypes;
var formatDuration = function formatDuration(seconds) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "hh:mm:ss";
  return !isNaN(seconds) ? "".concat(Math.sign(seconds) === -1 ? "-" : "").concat(_luxon.Duration.fromObject({
    seconds: Math.abs(seconds)
  }).toFormat(format)) : "";
};
var getSecondsFromObject = function getSecondsFromObject(_ref) {
  var _ref$sign = _ref.sign,
    sign = _ref$sign === void 0 ? 1 : _ref$sign,
    hours = _ref.hours,
    minutes = _ref.minutes,
    seconds = _ref.seconds;
  return hours || minutes || seconds ? sign * parseInt(_luxon.Duration.fromObject({
    hours: !isNaN(hours) ? hours : undefined,
    minutes: !isNaN(minutes) ? minutes : undefined,
    seconds: !isNaN(seconds) ? seconds : undefined
  }).toFormat("ss"), 10) : undefined;
};
var getDurationObject = function getDurationObject(durationInSeconds) {
  var _ref2 = durationInSeconds ? _luxon.Duration.fromObject({
      seconds: Math.abs(durationInSeconds)
    }).toFormat("hh:mm:ss").split(":").map(function (u) {
      return parseInt(u, 10);
    }) : [undefined, undefined, undefined],
    _ref3 = _slicedToArray(_ref2, 3),
    hours = _ref3[0],
    minutes = _ref3[1],
    seconds = _ref3[2];
  var sign = Math.sign(durationInSeconds) === -1 ? -1 : 1;
  return {
    hours: hours,
    minutes: minutes,
    seconds: seconds,
    sign: sign
  };
};
var DurationPicker = function DurationPicker(_ref4) {
  var children = _ref4.children,
    value = _ref4.value,
    hasError = _ref4.hasError,
    _ref4$placeholder = _ref4.placeholder,
    placeholder = _ref4$placeholder === void 0 ? "--:--:--" : _ref4$placeholder,
    _ref4$isRequired = _ref4.isRequired,
    isRequired = _ref4$isRequired === void 0 ? false : _ref4$isRequired,
    disabled = _ref4.disabled,
    onChange = _ref4.onChange,
    _onClose = _ref4.onClose,
    _ref4$format = _ref4.format,
    format = _ref4$format === void 0 ? "hh:mm:ss" : _ref4$format,
    w = _ref4.w,
    width = _ref4.width,
    _ref4$align = _ref4.align,
    align = _ref4$align === void 0 ? "start" : _ref4$align,
    hideDoneButton = _ref4.hideDoneButton,
    withClearButton = _ref4.withClearButton,
    _ref4$clearValue = _ref4.clearValue,
    clearValue = _ref4$clearValue === void 0 ? null : _ref4$clearValue,
    automationHook = _ref4.automationHook,
    isHighlighted = _ref4.isHighlighted,
    rest = _objectWithoutProperties(_ref4, _excluded);
  (0, _helpers.useDeprecate)({
    width: width
  }, "DurationPicker");
  var _useState = (0, _react.useState)(getDurationObject(value)),
    _useState2 = _slicedToArray(_useState, 2),
    durationObject = _useState2[0],
    setDurationObject = _useState2[1];
  (0, _react.useEffect)(function () {
    setDurationObject(value ? getDurationObject(value) : {});
  }, [value]);
  return /*#__PURE__*/_react["default"].createElement(_.Popover, {
    onClose: function onClose() {
      onChange === null || onChange === void 0 ? void 0 : onChange(getSecondsFromObject(durationObject));
      _onClose === null || _onClose === void 0 ? void 0 : _onClose();
    },
    align: align,
    triggerW: w !== null && w !== void 0 ? w : width /* TODO: deprecate width */,
    automationHook: automationHook,
    renderTrigger: children ? children : function (_ref5) {
      var togglePopover = _ref5.togglePopover,
        isOpen = _ref5.isOpen;
      return /*#__PURE__*/_react["default"].createElement(_.Input, {
        onClick: togglePopover,
        hasError: hasError,
        value: formatDuration(getSecondsFromObject(durationObject), format),
        placeholder: placeholder,
        isRequired: isRequired,
        disabled: disabled,
        automationHook: (0, _automationHooks.getHook)(automationHook, "trigger"),
        withClearButton: withClearButton,
        onClear: function onClear() {
          onChange === null || onChange === void 0 ? void 0 : onChange(clearValue);
          setDurationObject(getDurationObject(clearValue));
        },
        isHighlighted: isHighlighted
      });
    }
  }, function (_ref6) {
    var closePopover = _ref6.closePopover;
    return /*#__PURE__*/_react["default"].createElement(_.DurationPickerBase, _extends({
      onDoneClick: closePopover,
      value: durationObject,
      automationHook: automationHook,
      onChange: function onChange(seconds) {
        return setDurationObject(seconds);
      }
    }, rest));
  });
};
DurationPicker.propTypes = propTypes;
var _default = DurationPicker;
exports["default"] = _default;